// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"FormLabels_subtitle__D6CBR","link":"FormLabels_link___G6sE"};